import DB from "../db.js";
import { getUpdateInspectionPromise } from "./inspection.js";

export const UPDATE_PAGE = "UPDATE_PAGE";
export const OPEN_LOGIN_BOX = "OPEN_LOGIN_BOX";
export const LOGIN = "LOGIN";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGOUT = "LOGOUT";
export const INIT_DB = "INIT_DB";
export const CLOSE_DB = "CLOSE_DB";
export const GO_ONLINE = "GO_ONLINE";
export const GO_OFFLINE = "GO_OFFLINE";

export const navigateToRoute = route => dispatch => {
	var currentRoute = getRoute(location.pathname);
	var newRoute = { ...currentRoute, ...route };
	var pp = [newRoute.page];
	if (newRoute.id) pp.push(newRoute.id);
	if (newRoute.subpage) pp.push(newRoute.subpage);
	updatePage(newRoute, pp.join("/"), dispatch);
};

function getRoute(p) {
	var parts = p.split("/").slice(1);

	var route = {};
	route.page = parts[0];
	route.id = parts.length > 1 ? parts[1] : null;
	route.subpage = parts.length > 2 ? parts[2] : null;
	return route;
}

async function updatePage(route, p, dispatch, popstate) {
	if (!popstate) {
		const title = route.page + route.subpage ? " - " + route.subpage : "";
		history.pushState(route, title, p);
	}

	if (!localStorage.token || !localStorage.username) {
		dispatch(openLoginBox());
	}
	window.scrollTo(0, 0);

	// blur manually in order to force blur/change event to call on focused inputs
	if (document.activeElement && typeof document.activeElement.blur === "function") {
		document.activeElement.blur();
		await getUpdateInspectionPromise();
	}

	return dispatch({
		type: UPDATE_PAGE,
		route: route
	});
}

export const navigate = (path, popstate) => dispatch => {
	//routes:
	// /page , default /
	// /page/id/subpage , default /page/id/

	let p = path === "/" ? "/active-inspections" : path[0] === "/" ? path : location.pathname + "/" + path;

	var route = getRoute(p);

	return updatePage(route, p, dispatch, popstate);
};

export const goOnLine = () => dispatch => {
	return dispatch({ type: GO_ONLINE });
};

export const goOffLine = () => dispatch => {
	return dispatch({ type: GO_OFFLINE });
};

export const openLoginBox = () => dispatch => {
	return dispatch({ type: OPEN_LOGIN_BOX });
};

export function login(username, password) {
	return dispatch => {
		return fetch(window.INSP.config.apiUrl + "/api/auth", {
			method: "post",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ username, password })
		})
			.then(handleLoginErrors)
			.then(res => res.json())
			.then(json => {
				var t = parseJwt(json.token);
				if (localStorage.username != t.sub) {
					dispatch(initDb(t.sub));
				}
				dispatch(loginSuccess(json, t.sub));

				return json;
			})
			.catch(error => dispatch(loginError(error)));
	};
}

export function logout() {
	return async (dispatch, getState) => {
		dispatch(closeDb());
		const page = getState().app.route.page;

		let navProm = Promise.resolve();
		if (page === "inspection")
			navProm = dispatch(navigate("/active-inspections"));

		await navProm;
		dispatch(logoutSuccess());
	};
}

export function initDb(username) {
	return dispatch => {
		if (!username) {
			dispatch(closeDb());
			return;
		}

		let dbName = "InspX-" + username;

		DB.reconfigureDb(dbName);

		dispatch(initDbSuccess(dbName));
	};
}

const initDbSuccess = newName => ({
	type: INIT_DB,
	dbName: newName
});

const closeDb = () => {
	DB.reconfigureDb(null);
	return { type: CLOSE_DB };
};

const loginSuccess = (data, sub) => ({
	type: LOGIN,
	data: data,
	username: sub
});

const loginError = (error) => ({
	type: LOGIN_ERROR,
	error: error
});

const logoutSuccess = () => ({ type: LOGOUT });

function handleLoginErrors(response) {
	if (!response.ok) {
		if (response.status === 400 || response.status === 401) {
			throw Error("Incorrect username or password");
		}
		throw Error(response.statusText);
	}
	return response;
}

export function parseJwt(token) {
	var base64Url = token.split(".")[1];
	var base64 = base64Url.replace("-", "+").replace("_", "/");
	return JSON.parse(window.atob(base64));
}
